import { message } from 'antd';
import FetchData from '@ezviz/FetchData';
import util from '../../utils/utils';
import intl from 'react-intl-universal';


export const FETCH_ROLE_INFO_LOADING = 'FETCH_ROLE_INFO_LOADING';
export const FETCH_ROLE_INFO_SUCCESS = 'FETCH_ROLE_INFO_SUCCESS';
export const FETCH_ROLE_INFO_FAILED = 'FETCH_ROLE_INFO_FAILED';

export const FETCH_ROLE_DATA_LIST_LOADING = 'FETCH_DATA_LIST_LOADING';
export const FETCH_ROLE_DATA_LIST_SUCCESS = 'FETCH_DATA_LIST_SUCCESS';
export const FETCH_ROLE_DATA_LIST_FAILED = 'FETCH_DATA_LIST_FAILED';
export const DELETE_ROLE_SUCCESS = 'DELETE_ROLE_SUCCESS';
export const ADD_ROLE_SUCCESS = 'ADD_ROLE_SUCCESS';
export const EDIT_ROLE_SUCCESS = 'EDIT_ROLE_SUCCESS';

export const FETCH_MENU_SUCCESS = 'FETCH_MENU_SUCCESS';

/**
 * 获取当前登录用户角色权限信息
 * @param {*} param
 */
export function fetchRoleInfo(param) {
  return (dispatch, getState) => {
    const defaultParam = {
    }
    const req = Object.assign({}, defaultParam, param);
    dispatch({
      type: FETCH_ROLE_INFO_LOADING,
    });
    const fetchData = new FetchData(`${util.requestPath}/api/iot/support/account/info`, {
      method: 'GET',
      body: req,
      metaHandler: {
        403: () => { window.location.href = '/authrization/login'; return; }
      },
    });
    fetchData.then((res) => {
      if (res.code == 200) {
        const currentRoleInfo = res.data || {};
        const showContrl = {
          '0000000000001': false,  // 开发者信息
          '0000000000002': false,  // 常用管理
          '0000000000003': false,  // 产品管理
          '0000000000004': false,  // 用户查询
          '0000000000005': false,  // 设备查询
          '0000000000006': false,  // 客户分析
          '0000000000007': false,  // 数据分析
          '0000000000008': false,  // 账号管理
          '0000000000009': false,  // 角色管理
          '0000000000010': false,  // 品类管理
          '0000000000011': false,  // 创建产品
          '0000000000012': false,  // 查看所有PID
          '0000000000013': false,  // 功能定义编辑
          '0000000000014': false,  // 界面配置编辑
          '0000000000015': false,  // 固件管理编辑
          '0000000000016': false,  // 产品发布
          '0000000000017': false,  // 固件升级
          '0000000000018': false,  // 标准面板
          '0000000000019': false,  // APP灰度管理
          '0000000000020': false,  // 注销记录
          '0000000000021': false,  // 注销操作
          '0000000000022': false,  // 用户数据导出
        }
        // 是否展示无权限界面
        let isShowNoMenu = false;

        if (currentRoleInfo && currentRoleInfo.role) {
          const { menus } = currentRoleInfo.role;
          if (menus) {
            // 无任何权限
            if (menus.length > 0) {
              menus.forEach(item => {
                if (item) {
                  showContrl[item.mid] = true;
                }
              })
            } else {
              isShowNoMenu = true;
            }
          } else {
            isShowNoMenu = true;
          }
        } else {
          isShowNoMenu = true;
        }

        dispatch({
          type: FETCH_ROLE_INFO_SUCCESS,
          currentRoleInfo,
          showContrl,
          isShowNoMenu,
        });
      } else {

      }
    }).catch(e => {
      dispatch({
        type: FETCH_ROLE_INFO_FAILED
      })
    })
  };
}

/**
 * 获取角色列表
 * @param {*} param
 */
export function fetchRoleList(param) {
  return (dispatch, getState) => {
    const defaultParam = {
    }
    const req = Object.assign({}, defaultParam, param);
    dispatch({
      type: FETCH_ROLE_DATA_LIST_LOADING,
    });
    const fetchData = new FetchData(`${util.requestPath}/api/iot/support/role/list`, {
      method: 'GET',
      body: req,
    });
    fetchData.then((res) => {
      if (res.code == 200) {
        dispatch({
          type: FETCH_ROLE_DATA_LIST_SUCCESS,
          dataList: res.data.content || [],
          dataListTotal: res.data.totalSize,
          pageStart: res.data.pageIndex,
        });
      } else {
        message.error(res.msg || intl.get('commmon.operate.retry'));
        dispatch({
          type: FETCH_ROLE_DATA_LIST_FAILED,
        });
      }
    }).catch(e => {
      message.error(intl.get('commmon.operate.retry'));
      dispatch({
        type: FETCH_ROLE_DATA_LIST_FAILED,
      });
    })
  };
}

/**
 * 删除角色
 * @param {*} param
 */
export function deleteRole(param, callback, failback) {
  return (dispatch, getState) => {
    const defaultParam = {
    }
    const req = Object.assign({}, defaultParam, param);
    const fetchData = new FetchData(`${util.requestPath}/api/iot/support/role`, {
      method: 'DELETE',
      body: req,
    });
    fetchData.then((res) => {
      if (res.code == 200) {
        dispatch({
          type: DELETE_ROLE_SUCCESS,
        });
        callback && callback();
      } else {
        failback && failback();
        message.error(res.msg || intl.get('commmon.operate.retry'));
      }
    }).catch(e => {
      failback && failback();
      message.error(intl.get('commmon.operate.retry'));
    })
  };
}

/**
 * 新增角色
 * @param {*} param
 */
export function addRole(param, callback, failback) {
  return (dispatch, getState) => {
    const defaultParam = {
    }
    const req = Object.assign({}, defaultParam, param);
    const fetchData = new FetchData(`${util.requestPath}/api/iot/support/role`, {
      method: 'POST',
      body: req,
    });
    fetchData.then((res) => {
      if (res.code == 200) {
        dispatch({
          type: ADD_ROLE_SUCCESS,
        });
        callback && callback();
      } else {
        failback && failback();
        message.error(res.msg || intl.get('commmon.operate.retry'));
      }
    }).catch(e => {
      failback && failback();
      message.error(intl.get('commmon.operate.retry'));
    })
  };
}

/**
 * 修改角色
 * @param {*} param
 */
export function editRole(param, callback, failCallback) {
  return (dispatch, getState) => {
    const defaultParam = {
    }
    const req = Object.assign({}, defaultParam, param);
    const fetchData = new FetchData(`${util.requestPath}/api/iot/support/role`, {
      method: 'PUT',
      body: req,
    });
    fetchData.then((res) => {
      if (res.code == 200) {
        dispatch({
          type: EDIT_ROLE_SUCCESS,
        });
        callback && callback();
      } else {
        message.error(res.msg || intl.get('commmon.operate.retry'));
        failCallback && failCallback();
      }
    }).catch(e => {
      message.error(intl.get('commmon.operate.retry'));
    })
  };
}

/**
 * 获取菜单列表信息（角色权限信息）
 * @param {*} param
 */
export function fetchMenu(param, callback) {
  return (dispatch, getState) => {
    const defaultParam = {
    }
    const req = Object.assign({}, defaultParam, param);
    const fetchData = new FetchData(`${util.requestPath}/api/iot/support/menu`, {
      method: 'GET',
      body: req,
    });
    fetchData.then((res) => {
      if (res.code == 200) {
        dispatch({
          type: FETCH_MENU_SUCCESS,
          menu: res.data.content || [],
        });
        callback && callback();
      } else {
        message.error(res.msg || intl.get('commmon.operate.retry'));
      }
    }).catch(e => {
      message.error(intl.get('commmon.operate.retry'));
    })
  };
}
